import Ajv from 'ajv';

export const ajvValidator = new Ajv({ allErrors: true });
